import React, { FC, useState, useEffect, useContext } from 'react'
import { notify } from 'react-notify-toast'
import { isMobile } from 'react-device-detect'
import history from '../../history'

import GenericBackgroundLayer from '../../GenericComponents/GenericBackgroundLayer'
import NavigationBar from '../NavigationBar/NavigationBar'
import GenericTextSpan from '../../GenericComponents/GenericTextSpan'
import GenericMainCard from '../../GenericComponents/GenericMainCard'
import GenericSwitch from '../../GenericComponents/GenericSwitch'
import GenericButton from '../../GenericComponents/GenericButton'
import GenericLogo from '../../GenericComponents/GenericLogo'
import GenericInput from '../../GenericComponents/GenericInput'
import GenericRange from '../../GenericComponents/GenericRange'
import GenericIcon from '../../GenericComponents/GenericIcon'
import GenericRow from '../../GenericComponents/GenericRow'
import GenericMobileTopNavigation from '../../GenericComponents/GenericMobileTopNavigation'

import AppContext from '../../context/appContext'
import changeLocation from '../../utils/changeLocalization'

import {
  setHydrationAlert,
  getHydrationAlert,
  patchHydrationAlert,
  getUserData,
  getUserFeed,
  getTrainingDays,
} from '../../Api/backendApi'
import { patchDiet } from '../../Api/dietApi/userInfo'

import { WaterInputContainer } from './style/WaterReminderStyle'

interface WaterReminderInterface {}

const WaterScreen: FC<WaterReminderInterface> = ({}) => {
  const appContext = useContext(AppContext)
  const [user, setUser] = useState(Object)
  const [waterReminder, setWaterReminder] = useState({
    fromHour: 0,
    toHour: 0,
  })
  const [remindUserSwitch, setRemindUserSwitch] = useState(false)
  const [waterDataId, setWaterDataId] = useState()

  useEffect(() => {
    obtainUser()
    getWaterData()
  }, [])

  const obtainUser = async () => {
    if (appContext.appState.user) {
      setUser(appContext.appState.user)
    }

    const user = await getUserData()

    setUser(user)
    appContext.updateAppState('user', user)
  }

  const getWaterData = async () => {
    if (appContext && appContext.appState.waterData) {
      setWaterReminder({
        fromHour: appContext.appState.waterData.start_hour,
        toHour: appContext.appState.waterData.end_hour,
      })
      setWaterDataId(appContext.appState.waterData.id)
      setRemindUserSwitch(appContext.appState.waterData.notification_enabled)
    }

    const waterData: any = await getHydrationAlert()
    await appContext.updateAppState('waterData', waterData.data)
    // setUser(user)
    // appContext.updateAppState('user', user)

    setWaterReminder({
      fromHour: waterData.data.start_hour,
      toHour: waterData.data.end_hour,
    })
    setWaterDataId(waterData.data.id)
    setRemindUserSwitch(waterData.data.notification_enabled)
  }

  const setWaterData = () => {
    setHydrationAlert(
      waterReminder.fromHour,
      waterReminder.toHour,
      remindUserSwitch
    )
  }

  const patchWaterData = () => {
    patchHydrationAlert()
  }

  const handleObtainWaterReminderData = (mode: string, value: any) => {
    switch (mode) {
      case 'from':
        setWaterReminder({
          ...waterReminder,
          fromHour: parseInt(value.split(':')[0]),
        })
        break
      case 'to':
        setWaterReminder({
          ...waterReminder,
          toHour: parseInt(value.split(':')[0]),
        })
        break

      default:
        break
    }
  }

  return (
    <GenericBackgroundLayer
      fDir={'column'}
      justify={'flex-start'}
      align={'center'}
      className={`${
        appContext.appState.theme == 'light' ? 'light' : 'standard'
      }`}
    >
      {isMobile && (
        <GenericMobileTopNavigation
          dietCartClick={null}
          isPlayerView={false}
          handleClick={() => history.push('/twoj-profil')}
        />
      )}
      <NavigationBar
        isPlayerView={false}
        backButtonAction={() => changeLocation('/trening')}
      />
      <GenericMainCard
        margin={'5% auto 0 auto'}
        maxWidth={'1000px'}
        className="standard"
        width={isMobile ? '95%' : '60%'}
        flexDir="column"
      >
        <GenericTextSpan fSize={'1.6rem'} margin={'0 0 5% 0'}>
          Godziny przypominania o piciu wody
        </GenericTextSpan>
        <WaterInputContainer>
          <GenericTextSpan fSize={''}>Od</GenericTextSpan>
          <GenericInput
            onChange={(e: any) =>
              handleObtainWaterReminderData('from', e.target.value)
            }
            maxWidth={isMobile ? '75%' : '32%'}
            autoFocus
            fSize={isMobile ? '2.5rem ' : '3rem'}
            className={'no-border color-white text-center'}
            type="time"
            value={waterReminder.fromHour && `${waterReminder.fromHour}:00`}
            placeholder={
              waterReminder.fromHour ? waterReminder.fromHour : '00:00'
            }
          ></GenericInput>
        </WaterInputContainer>

        <WaterInputContainer>
          <GenericTextSpan fSize={''}>Do</GenericTextSpan>
          <GenericInput
            onChange={(e: any) =>
              handleObtainWaterReminderData('to', e.target.value)
            }
            maxWidth={isMobile ? '75%' : '32%'}
            autoFocus
            fSize={isMobile ? '2.5rem ' : '3rem'}
            className={'no-border color-white text-center'}
            type="time"
            value={waterReminder.toHour && `${waterReminder.toHour}:00`}
          ></GenericInput>
        </WaterInputContainer>

        <GenericTextSpan
          fSize={isMobile ? '1.1rem' : '1.3rem'}
          width={isMobile ? '75%' : 'unset'}
          margin={'0 0 5% 0'}
        >
          Powiadomienia będziesz otrzymywała co godzinę
        </GenericTextSpan>
        <GenericRow>
          <GenericSwitch
            text={'Przypominaj o piciu wody'}
            handleChange={setRemindUserSwitch}
            checked={remindUserSwitch}
            defaultChecked={false}
          ></GenericSwitch>
        </GenericRow>

        <GenericButton
          margin={'5% 0 0 0'}
          justify={'center'}
          width={'40%'}
          className={'standard'}
          onClick={() => setWaterData()}
        >
          Zapisz
        </GenericButton>
      </GenericMainCard>
      {!isMobile && (
        <GenericLogo
          theme={appContext.appState.theme == 'light' ? 'light' : null}
          margin={'2% auto 0 auto'}
        />
      )}
    </GenericBackgroundLayer>
  )
}

export default WaterScreen
